import { useAPICallAsync } from '@michelin/central-provider';
import { useMutation } from 'react-query';
import { rubyOrderRoute as baseRoute } from 'services/restApiConst';
import { OrderResponseType } from 'types/APIResponse';
import { AppointmentType } from 'types/UFOTypes';

interface CreateOrderParams {
  mobile_address?: {
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
  contact_id?: string;
  customerType?: 'fleet' | 'dealer';
  vehicle_id?: string;
  provider_id: string;
  provider_location_id: string;
  orderer_id: string;
  orderer_location_id: string;
  order_type?: string;
  pickup_id: string;
  delivery_id: string;
  delivery_method: string;
  parts?: { part_id: string; quantity: number; dealer_part_id?: string }[];
  appointment?: string;
  vehicle_type: string;
  credit_card_token?: string;
  credit_card_last_four?: string;
  po_number?: string;
  authorization_number?: string;
  payment_type?: string;
  appointment_type?: AppointmentType;
  reference_number?: string;
  vehicle?: { vin?: string };
}

export const useOrderCreate = () => {
  const { call } = useAPICallAsync<OrderResponseType, CreateOrderParams>({
    api: {
      method: 'POST',
      endpoint: 'orders',
    },
    baseRoute,
  });

  const mutation = useMutation((params: { payload: CreateOrderParams }) => {
    return call(params.payload, undefined, true);
  });

  const { isLoading, data, error } = mutation;

  const mutate = async (params: CreateOrderParams) => {
    const { data: order } = await mutation.mutateAsync({ payload: params });
    return { data: order };
  };

  return {
    ...data,
    error,
    loading: isLoading,
    create: mutate,
  };
};
